export default __webpack_public_path__ + "static/media/recurrence.de57cbeb.svg";